const getters = {
  token: state => state.token,
  openid: state => state.openid,
  userid: state => state.userid,
  // userid: state => 'Mini_309d5768-c9d1-4081-85dc-9d07aed4f13f'
}
export default getters
